import { Drawer, Input } from '@mantine/core';
import { isArray } from "lodash"
import React, { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom';

const tmpDir = window.api?.os.platform() === "darwin" ? "/tmp" : window.api?.os.tmpdir();
const logFolderPath = window.api?.path.join(tmpDir, "hidemium_4-work-logs");
const Log = () => {
  const [searchParams] = useSearchParams();
  const isInScriptWindow = searchParams.get('window') === "script";
  const [opened, setOpened] = useState(false);
  const [variables, setVariables] = useState([]);
  const [content, setContent] = useState('');
  const fileWatcherChannel = useRef(null);
  const filePath = window.api?.path.join(logFolderPath, "run_test.txt");

  useEffect(() => {
    if (isInScriptWindow) {
      window.electron?.ipcRenderer.on('showLog', () => {
        setOpened(true)
      })
    }
    return () => {
      window.electron?.ipcRenderer.removeAllListeners('showLog');
    }
  }, []);

  useEffect(() => {
    if (isInScriptWindow && opened) {
      window.electron?.ipcRenderer.on('variables-log', (_, data) => {
        const newVariables = []
        if (isArray(data)) {
          for (const item of data) {
            newVariables.push({ label: item.value, data: item.data })
          }
        } else {
          for (const key in data) {
            newVariables.push({ label: key, data: data[key] })
          }
        }
        setVariables(newVariables)
      })
      return () => {
        window.electron?.ipcRenderer.removeAllListeners('variables-log')
      }
    }
  }, [opened])

  const showLog = async () => {
    if (!window.api?.fs.existsSync(logFolderPath)) window.api?.fs.mkdirSync(logFolderPath, { recursive: true })
    if (!window.api?.fs.existsSync(filePath)) window.api?.fs.writeFileSync(filePath, "")
    setContent(window.api?.fs.readFileSync(filePath, { encoding: 'utf8' }))
    fileWatcherChannel.current = await window.api?.startWatchFile(filePath)
    window.electron?.ipcRenderer.on(fileWatcherChannel.current, () => {
      setContent(window.api?.fs.readFileSync(filePath, { encoding: 'utf8' }))
    })
  }

  useEffect(() => {
    if (opened) {
      showLog();
    }
    return () => {
      window.api?.stopWatchFile(fileWatcherChannel.current);
      window.electron?.ipcRenderer.removeAllListeners(fileWatcherChannel.current);
    }
  }, [opened])

  const formatTerminalText = (text) => {
    const getTextColorByContent = (word) => {
      const upperWord = word.toUpperCase();
      if (upperWord === "SUCCESS") return '#4ade80';
      if (upperWord === "ERROR") return '#ff0000';
      return '#e6edf3';
    };

    const cleanWords = (words) => {
      const cleaned = [];
      let i = 0;
      while (i < words.length) {
        // Remove "| ERROR |" pattern near the end
        if (
          i < words.length - 3 &&
          words[i] === "|" &&
          words[i + 1].toUpperCase() === "ERROR" &&
          words[i + 2] === "|"
        ) {
          i += 3; // Skip these three tokens
          continue;
        }

        if (words[i] === "|" && words[i + 1] === "|") {
          cleaned.push("|");
          while (i < words.length && words[i] === "|") i++;
        } else {
          cleaned.push(words[i]);
          i++;
        }
      }
      return cleaned;
    };

    const lines = text.split("\n");
    const formattedLines = lines.map((line, index) => {
      const words = line.trim().split(/\s+/);
      let formattedWords = [];

      if (
        words.length >= 2 &&
        /^\d{4}-\d{2}-\d{2}$/.test(words[0]) &&
        /^\d{2}:\d{2}:\d{2}$/.test(words[1])
      ) {
        const timestamp = `${words[0]} ${words[1]}`;
        const statusIndex = words.findIndex(
          (word) =>
          word.toUpperCase() === "SUCCESS" || word.toUpperCase() === "ERROR"
        );

        if (statusIndex !== -1) {
          const status = words[statusIndex];
          const displayStatus = status.toUpperCase();
          const remainingWords = cleanWords(
            words.slice(2, statusIndex).concat(words.slice(statusIndex + 1))
          );
          formattedWords = [
            <span key={0}>
              {timestamp} {">"}{" "}
            </span>,
            <span
              key={1}
              style={{
                color: getTextColorByContent(status),
                fontWeight: "bold",
              }}
            >
              {displayStatus}:{remainingWords.length > 0 ? " " : ""}
            </span>,
            <span key={2}>{remainingWords.join(" ")}</span>,
          ];
        } else {
          const remainingWords = cleanWords(words.slice(2));
          formattedWords = [
            <span key={0}>
              {timestamp} {">"}{" "}
            </span>,
            <span key={1}>{remainingWords.join(" ")}</span>,
          ];
        }
      } else {
        formattedWords = [<span key={0}>{cleanWords(words).join(" ")}</span>];
      }
      return <div key={index}>{formattedWords}</div>;
    });

    return formattedLines;
  };

  return (
    <>
      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        title="Log Detail"
        padding="xl"
        size="xl"
        position="right"
        zIndex={9999}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: "column",
            height: 'calc(100vh - 92px)',
            fontSize: '0.85rem',
          }}
        >
          <div
            style={{
              flex: 1,
              border: '1px solid #eaeaea',
              whiteSpace: 'pre-line',
              lineHeight: 2,
              overflow: 'auto',
            }}
          >
            {formatTerminalText(content)}
          </div>
          <div
            style={{
              flex: 1,
              marginTop: 8,
              border: '1px solid #eaeaea',
              overflow: 'auto',
            }}
          >
            {
              variables.map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      width: '50%',
                      display: 'inline-block',
                      padding: 8
                    }}
                  >
                    <div>{item.label}</div>
                    <Input disabled value={item.data} />
                  </div>
                )
              })
            }
          </div>
        </div>
      </Drawer>
    </>
  )
}

export default Log
